module.exports = __webpack_public_path__ + "static/media/arrow-up.85678c06.svg";